
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dino-egg",
      function () {
        return require("private-next-pages/dino-egg/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dino-egg"])
      });
    }
  